import { useMemo } from "react"

import { ReportingAreaChart } from "@/components/reporting/charts"
import { api } from "@/lib/api"
import { formatDayLabel, formatDayTick } from "./week-label"

export function AiAgentActiveWorkspacesChart() {
	const query = api.analytics.aiAgentActiveWorkspacesChart.useQuery({})

	const chartData = useMemo(
		() =>
			(query.data ?? []).map((item) => ({
				date: formatDayTick(item.bucket),
				rangeLabel: formatDayLabel(item.bucket),
				count: item.count,
			})),
		[query.data],
	)
	const latest = query.data?.at(-1)?.count

	return (
		<ReportingAreaChart
			title="Companies using the agent"
			description="Paying workspaces where the agent answered a customer in the 30 days up to each day. A workspace drops out 30 days after its last answer."
			data={chartData}
			series={[{ key: "count", label: "Companies", tone: "primary" }]}
			isLoading={query.isLoading}
			legend={
				latest === undefined ? undefined : (
					<div className="text-right">
						<p className="text-2xl font-semibold tabular-nums text-primary">
							{latest.toLocaleString("en-US")}
						</p>
						<p className="text-xs text-tertiary">today</p>
					</div>
				)
			}
		/>
	)
}
